import React from 'react';
import { Card, Flex } from '@radix-ui/themes';

import * as Types from '../../../../types';

import { NodeContextMenu } from '../../ContextMenu';
import { ABIDecoderNode } from './abi_decoder';
import { UnitConverterNode } from './unit_converter';
import { LLMCallNode } from './llm_call';
import { WorkflowNodeProps } from '..';

const nodeComponentMap: Record<
  Types.TransformerType,
  React.ComponentType<WorkflowNodeProps<Types.TransformerNode>>
> = {
  [Types.TransformerType.AbiDecoder]: ABIDecoderNode,
  [Types.TransformerType.UnitConverter]: UnitConverterNode,
  [Types.TransformerType.LlmCall]: LLMCallNode,
};

function TransformerNode(props: WorkflowNodeProps<Types.TransformerNode>) {
  const { id, data, onDelete, onClick, onChange } = props;

  const NodeComponent = nodeComponentMap[data.transformer.transformerType];

  if (!NodeComponent) {
    return (
      <NodeContextMenu onDelete={() => onDelete(id)}>
        <Card style={{ width: '300px', border: '1px dashed orange' }}>
          Unknown Transformer Type: {data.transformer.transformerType}
        </Card>
      </NodeContextMenu>
    );
  }

  console.log('TransformerNode', data);
  console.log('TransformerNode', props);
  return (
    <NodeContextMenu onDelete={() => onDelete(id)}>
      <Card style={{ width: '300px' }} onClick={onClick}>
        <Flex direction="column" gap="2">
          <NodeComponent {...props} />
        </Flex>
      </Card>
    </NodeContextMenu>
  );
}

export default TransformerNode;
